import {Box, HStack, Text} from 'platform/foundation-tw';

import {useTranslation} from 'react-i18next';

const COPYRIGHT_START_YEAR = 2021;
const MAX_CONTENT_WIDTH = '108rem';
const APP_VERSION = '1.0.0';

function getCopyrightYears() {
  const currentYear = new Date().getFullYear();
  if (currentYear <= COPYRIGHT_START_YEAR) {
    return String(COPYRIGHT_START_YEAR);
  }
  return `${COPYRIGHT_START_YEAR}\u2013${currentYear}`;
}

export function Footer() {
  const {t} = useTranslation();

  return (
    <footer>
      <Box maxWidth={MAX_CONTENT_WIDTH} center width="100%">
        <Box paddingHorizontal={8} paddingTop={6} paddingBottom={8}>
          <HStack spacing={4} align="center" justify="space-between">
            <Text size="xSmall" color="tertiary">
              {t('footer.copyright', {years: getCopyrightYears()})}
            </Text>
            <Text size="xSmall" color="tertiary">
              {t('footer.version', {version: APP_VERSION})}
            </Text>
          </HStack>
        </Box>
      </Box>
    </footer>
  );
}
